import {useSession} from 'next-auth/react'
import {useEffect} from 'react'

import {FormActivate} from '@/components/common/form/user-auth/FormActivate'
import {FormSignIn} from '@/components/common/form/user-auth/FormSignIn'
import {useUserData} from '@/components/context/UserData'
import {UserState} from '@/utils/user/constants'
import {isAdminRole} from '@/utils/user/helpers'
import {useExistingUserData} from '@/utils/user/hooks'

export const useContactAccountState = (
  validEmail: string | null,
  currentEmail: string | undefined,
  onPrefillEmail: (email: string) => void,
) => {
  const {data: session} = useSession()
  const data = useUserData()
  const [userExistenceData, checkUserExistence] = useExistingUserData(validEmail)
  const isLoading = data.isLoading
  const isAdmin = isAdminRole(data.user)
  const isLoggedInCustomer = Boolean(session) && !isAdmin

  const visibleAuthForm = Boolean(userExistenceData) && !session
  const hasAccount = Boolean(
    userExistenceData?.userExists && userExistenceData?.userState !== UserState.Invited,
  )
  const signInNotice =
    (userExistenceData?.userState === UserState.Active && <FormSignIn />) ||
    (userExistenceData?.userState === UserState.Created && <FormActivate />)

  useEffect(() => {
    // email is the only profile field carried into the form for a logged-in customer
    if (!isLoading && !isAdmin && !currentEmail && data.user?.email) {
      onPrefillEmail(data.user.email)
    }
    // I want to run it just when isLoading changes state
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isAdmin])

  return {
    user: data.user,
    isLoading,
    isAdmin,
    isLoggedInCustomer,
    visibleAuthForm,
    hasAccount,
    signInNotice,
    checkUserExistence,
  }
}
